// 脏腑辨证模块
// tizhi_zangfu 已在 pipeline.parseBase 中完成 JSON.parse（含空对象兜底）
// 当前无额外清洗需求，保留该文件作为扩展入口
export default function transform(/* data */) {
    // no-op
}
